<mvp-nav></mvp-nav>
<div class="container">
    <router-outlet></router-outlet>
</div>
